import { StyleSheet } from 'aphrodite';
import COLORS from '../../library/colors';

const styles = StyleSheet.create({
  root: {},
  detailsContainer: {
    padding: 16
  },
  progressBar: {
    border: '1px solid whitesmoke',
    width: '100%',
    borderRadius: 24,
    overflow: 'hidden',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25) inset',
    background: 'whitesmoke'
  },
  progress: {
    background: '#46a4ff',
    height: 8
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/booking-summary/booking-summary-styles.js